import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class MerchantShipSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.MERCHANT_SHIP;
}

export default MerchantShipSalvageableTileEntity;
